/**
 * The Beacon API is used to send an asynchronous and non-blocking request to a web server.
 * The request does not expect a response.
 * Unlike requests made using XMLHttpRequest or the Fetch API, the browser guarantees to
 * initiate beacon requests before the page is unloaded and to run them to completion.
 *
 * @param {string} url - The URL to which the data will be transmitted
 * @param {Object} data - The data to be sent
 * @returns {void}
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon MDN sendBeacon}
 */
export function sendBeacon(url, data) {
  navigator?.sendBeacon &&
    navigator.sendBeacon(url, new Blob([data], { type: "application/json" }))
}
